import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "../../../shared/api";

export const useDeleteUniformItem = () => {
  const { sport, organizationId } = useParams();
  const { mutateData } = useApi();

  return useMutation({
    mutationFn: (uniformItemId: string) => {
      return mutateData({
        url: `${sport}/o/${organizationId}/uniforms/items/${uniformItemId}`,
        method: "DELETE",
      });
    },
  });
};
